const formatResponse = (res) => {
  if (res) {
    return {
      status: res.status,
      statusText: res.statusText,
      data: res.data,
    }
  }
  return null
}

const formatSystemError = (error) => {
  /**
   * error.response.status: 405
   * error.response.statusText: "Method Not Allowed"
   */
  return { status: "error", error }
}

const getCookie = (key) => {
  let cookieValue = null
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";")
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      // Does this cookie string begin with the key we want?
      if (cookie.substring(0, key.length + 1) === key + "=") {
        cookieValue = decodeURIComponent(cookie.substring(key.length + 1))
        break
      }
    }
  }
  return cookieValue
}

const setCookie = (key, value, days = 1, sameSite = "Strict") => {
  const maxAge = 60 * 60 * 24 * days
  const sameSiteAttr = sameSite ? `same-site=${sameSite.toLowerCase()};` : ""
  document.cookie = `${key}=${value}; path=/; max-age=${maxAge}; ${sameSiteAttr}${process.env.NODE_ENV === "production" ? "secure;" : ""}`
}

const deleteCookie = (key) => {
  document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
}

function setLocalStorage(key, value, days) {
  const now = new Date()
  let item

  if (days !== undefined) {
    // Convert days to milliseconds if days is provided
    const ttl = days * 24 * 60 * 60 * 1000
    item = {
      value: value,
      expiry: now.getTime() + ttl,
    }
  } else {
    // No expiry date, just store the value
    item = {
      value: value,
      expiry: null, // or omit expiry property entirely if preferred
    }
  }

  localStorage.setItem(key, JSON.stringify(item))
}

// const csrfCookie = getCookie("csrftoken")

const options = {
  headers: {
    // "X-CSRFTOKEN": csrfCookie,
  },
}

function getLocalStorage(key) {
  const itemStr = localStorage.getItem(key)
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()

  // compare the expiry time of the item with the current time
  if (item.expiry && now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key)
    return null
  }
  return item.value
}

export { options, getCookie, setCookie, deleteCookie, setLocalStorage, getLocalStorage }
